import { __decorate, __metadata } from "tslib";
import { DocumentsResponse, IdvSkippedResponse, UpdateIdentityVerificationDetailResponse, } from '@cbbt/itf-unverified-individual-customer-domain';
import { BaseService, HTTP_METHOD, Method, restParamMapper, Service, STATUS, } from '@cbbt/lib-interface';
import { ApplicationValidationError } from './error/ApplicationValidationError.js';
import { AdditionalDocumentRequest } from './models/AdditionalDocumentRequest.js';
import { ExternalTokenRequest } from './models/ExternalTokenRequest.js';
import { ExternalTokenResponse } from './models/ExternalTokenResponse.js';
import { GetIdvIndividualRequest } from './models/GetIdvIndividualRequest.js';
import { GetIdvIndividualResponse } from './models/GetIdvIndividualResponse.js';
import { IDVSkippedRequest } from './models/IDVSkippedRequest.js';
import { IDVSubmitRequest } from './models/IDVSubmitRequest.js';
import { IDVSubmitResponse } from './models/IDVSubmitResponse.js';
import { ServiceTokenRequest } from './models/ServiceTokenRequest.js';
import { ServiceTokenResponse } from './models/ServiceTokenResponse.js';
import { UpdateRetryCountRequest } from './models/UpdateRetryCountRequest.js';
let IdentityVerificationChannelService = class IdentityVerificationChannelService extends BaseService {
    submit(_transport, request) {
        return this.unimplemented(request);
    }
    updateRetryCount(_transport, request) {
        return this.unimplemented(request);
    }
    addAdditionalDocument(_transport, request) {
        return this.unimplemented(request);
    }
    skipIdentitiyVerification(_transport, request) {
        return this.unimplemented(request);
    }
    jwtTokenGenerate(_transport, request) {
        return this.unimplemented(request);
    }
    jwtServiceTokenGenerate(_transport, request) {
        return this.unimplemented(request);
    }
    getIdvIndividual(_transport, request) {
        return this.unimplemented(request);
    }
};
__decorate([
    Method({
        summary: 'IDV Submit',
        description: 'Submit ID&V along with all the details',
        successStatus: STATUS.CREATED,
        throws: [ApplicationValidationError],
    }),
    Method.rest({
        path: '/application/{applicationId}/individual/{individualId}/submit',
        method: HTTP_METHOD.POST,
        body: restParamMapper.json(),
        params: [
            restParamMapper.path({ from: 'applicationId', to: 'applicationId' }),
            restParamMapper.path({ from: 'individualId', to: 'individualId' }),
            restParamMapper.header({ from: 'x-lbg-brand', to: 'brand' }),
            restParamMapper.header({ from: 'x-lbg-bcb-jwt', to: 'jwt' }),
        ],
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, IDVSubmitRequest]),
    __metadata("design:returntype", IDVSubmitResponse)
], IdentityVerificationChannelService.prototype, "submit", null);
__decorate([
    Method({
        summary: 'IDV Update Retry count',
        description: 'Update retry count for ID&V along with all the details',
        successStatus: STATUS.OK,
        throws: [ApplicationValidationError],
    }),
    Method.rest({
        path: '/application/{applicationId}/individual/{individualId}/updateRetryCount',
        method: HTTP_METHOD.PUT,
        body: restParamMapper.json(),
        params: [
            restParamMapper.path({ from: 'applicationId', to: 'applicationId' }),
            restParamMapper.path({ from: 'individualId', to: 'id' }),
            restParamMapper.header({ from: 'x-lbg-brand', to: 'brand' }),
            restParamMapper.header({ from: 'x-lbg-bcb-jwt', to: 'jwt' }),
            restParamMapper.query({ from: 'isReset', to: 'isReset' }),
        ],
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, UpdateRetryCountRequest]),
    __metadata("design:returntype", UpdateIdentityVerificationDetailResponse)
], IdentityVerificationChannelService.prototype, "updateRetryCount", null);
__decorate([
    Method({
        summary: 'Add Additional Document',
        description: 'Add Additional Document Based On Basic Logic',
        successStatus: STATUS.CREATED,
        throws: [ApplicationValidationError],
    }),
    Method.rest({
        path: '/application/{applicationId}/individual/{individualId}/additionalDocument',
        method: HTTP_METHOD.POST,
        body: restParamMapper.json(),
        params: [
            restParamMapper.path({ from: 'applicationId', to: 'applicationId' }),
            restParamMapper.path({ from: 'individualId', to: 'individualId' }),
            restParamMapper.header({ from: 'x-lbg-brand', to: 'brand' }),
            restParamMapper.header({ from: 'x-lbg-bcb-jwt', to: 'jwt' }),
        ],
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, AdditionalDocumentRequest]),
    __metadata("design:returntype", DocumentsResponse)
], IdentityVerificationChannelService.prototype, "addAdditionalDocument", null);
__decorate([
    Method({
        summary: 'IDV skip',
        description: 'IDV skip',
        successStatus: STATUS.CREATED,
        throws: [ApplicationValidationError],
    }),
    Method.rest({
        path: '/application/{applicationId}/individual/{individualId}/updateIdvSkip',
        method: HTTP_METHOD.POST,
        body: restParamMapper.json(),
        params: [
            restParamMapper.path({ from: 'individualId', to: 'individualId' }),
            restParamMapper.path({ from: 'applicationId', to: 'applicationId' }),
            restParamMapper.header({ from: 'x-lbg-brand', to: 'brand' }),
            restParamMapper.header({ from: 'x-lbg-bcb-jwt', to: 'jwt' }),
        ],
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, IDVSkippedRequest]),
    __metadata("design:returntype", IdvSkippedResponse)
], IdentityVerificationChannelService.prototype, "skipIdentitiyVerification", null);
__decorate([
    Method({
        summary: 'JWT token',
        description: 'JWT token',
        successStatus: STATUS.OK,
    }),
    Method.rest({
        path: '/application/{applicationId}/individual/{individualId}/idv-jwt',
        method: HTTP_METHOD.GET,
        params: [
            restParamMapper.header({ from: 'x-lbg-brand', to: 'brand' }),
            restParamMapper.header({ from: 'x-lbg-bcb-jwt', to: 'jwt' }),
            restParamMapper.header({
                from: 'x-lbg-idv-session-id',
                to: 'sessionId',
            }),
            restParamMapper.path({ from: 'applicationId', to: 'applicationId' }),
            restParamMapper.path({ from: 'individualId', to: 'individualId' }),
            restParamMapper.query({ from: 'isApplicable', to: 'isApplicable' }),
        ],
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, ExternalTokenRequest]),
    __metadata("design:returntype", ExternalTokenResponse)
], IdentityVerificationChannelService.prototype, "jwtTokenGenerate", null);
__decorate([
    Method({
        summary: 'JWT service token',
        description: 'JWT service token',
        successStatus: STATUS.OK,
    }),
    Method.rest({
        path: '/application/{applicationId}/individual/{individualId}/serviceToken',
        method: HTTP_METHOD.POST,
        body: restParamMapper.json(),
        params: [
            restParamMapper.header({ from: 'x-lbg-bcb-jwt', to: 'jwt' }),
            restParamMapper.header({ from: 'x-lbg-brand', to: 'brand' }),
            restParamMapper.path({ from: 'applicationId', to: 'applicationId' }),
            restParamMapper.path({ from: 'individualId', to: 'individualId' }),
        ],
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, ServiceTokenRequest]),
    __metadata("design:returntype", ServiceTokenResponse)
], IdentityVerificationChannelService.prototype, "jwtServiceTokenGenerate", null);
__decorate([
    Method({
        summary: 'Get individual for idv',
        description: 'Get individual for idv',
        successStatus: STATUS.OK,
    }),
    Method.rest({
        path: '/application/{applicationId}/individual/{individualId}/getIdvIndividual',
        method: HTTP_METHOD.GET,
        params: [
            restParamMapper.header({ from: 'x-lbg-brand', to: 'brand' }),
            restParamMapper.header({ from: 'x-lbg-bcb-jwt', to: 'jwt' }),
            restParamMapper.path({ from: 'applicationId', to: 'applicationId' }),
            restParamMapper.path({ from: 'individualId', to: 'individualId' }),
        ],
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, GetIdvIndividualRequest]),
    __metadata("design:returntype", GetIdvIndividualResponse)
], IdentityVerificationChannelService.prototype, "getIdvIndividual", null);
IdentityVerificationChannelService = __decorate([
    Service({
        description: 'This is an orchestration service for IDV',
    }),
    Service.rest({
        basePath: '/kyc',
    })
], IdentityVerificationChannelService);
export { IdentityVerificationChannelService };
//# sourceMappingURL=IdentityVerificationChannelService.js.map